<template>
  <div :class="(hide > 0) ? 'hide' : ''" class="EventOddGroup-styles-odd-group-container">
    <div class="EventOddGroup-styles-fixed-param-texts undefined" v-if="market && !match.isSuspended && typeof market.specialKey !== 'undefined'">
      <div class="EventOddGroup-styles-fixed-param-text">{{ market[market.specialKey] }}</div>
      <div class="EventOddGroup-styles-fixed-param-text" v-if="halfMarket">{{ halfMarket[market.specialKey] }}</div>
    </div>
    <div class="EventOddGroup-styles-odd-groups" v-if="!market && match.isSuspended" data-testid="odd-groups">
      <div class="EventOddGroup-styles-odd-group no-market">
        <button id="odd-79844413910-button" class="EventOddButton-styles-odd-button"><span>
          <i class="iconx icon-lock"></i>
        </span>
        </button>
        <button id="odd-79844414010-button" class="EventOddButton-styles-odd-button">
          <span><i class="iconx icon-lock"></i></span>
        </button>
        <button id="odd-79844414110-button" class="EventOddButton-styles-odd-button">
          <span><i class="iconx icon-lock"></i></span>
        </button>
      </div>
    </div>
    <div class="EventOddGroup-styles-odd-groups" v-if="market && !match.isSuspended">
      <div class="EventOddGroup-styles-odd-group">
        <Selection :odd="odd" :market="market" :match="match" v-for="odd in market.odd" />
      </div>
      <div class="EventOddGroup-styles-odd-group" v-if="halfMarket">
        <Selection :odd="odd" :market="halfMarket" :match="match" v-for="odd in halfMarket.odd" />
      </div>
    </div>
  </div>
</template>

<script>

import Selection from "./selection";
export default {
  name: "marketOdd",
  props: ['odds', 'id', 'match' , 'hide'],
  components: {Selection},
  data () {
    return {
      market: null,
      halfMarket: null,
      special: null,
      selectedMarket: null,
      ag: 0
    }
  },
  watch: {
    '$store.state.marketSelect' (v) {
      if(v.cell == this.id && v.onLive == this.match.onLive){
        this.selectedMarket = v.market;
        this.findMarket();
      }
    },
    'odds' () {
      this.findMarket();
    },
  },
  mounted() {
    var self = this;

  },
  methods: {
      findMarket(){
        var payload = this.selectedMarket;
        var self = this;
        self.market = null;
        if(self.odds){
          self.halfMarket = null;

          var GoalMarkets = []

          Object.values(self.odds).forEach(value => {
            var ag = 0;

            Object.values(value.odd).forEach((v) => {
              var oddn = parseFloat(v.odd);
              if(v.odd <= 4){
                ag = (oddn + ag);
              }else {
                ag = 99;
              }
            });

            if(self.selectedMarket.e == 5498 && value.market == 5518){
                    self.halfMarket = value
              }

              if(self.selectedMarket.e === 12553 && (value.market === 247)){
                  self.halfMarket = value

              }

              if(self.selectedMarket.e === 5506 && (value.market === 338 || value.market === 10435)){
                  self.halfMarket = value

              }
            

            if(payload && (value.market === payload.e || payload.sub.includes(""+value.market+"") || marketType['m_'+value.mid].p == payload.e)){
              
              if(value.market === 5506){

                GoalMarkets.push(value)

                Object.values(this.sortByKey(GoalMarkets, 'sp')).forEach(gvalue => {
                  if(gvalue.odd.length > 0)
                    self.market = gvalue;
                })

              }else if(value.market === 5500){

                var Time = parseFloat(self.match.periodTime)

                if(Time <= 1620 && value.sp == 2.5){
                  self.market = value;
                }else if(Time > 1620 && Time <= 3420 && value.sp == 1.5){
                  self.market = value;
                }else if(Time > 3420 && Time <= 35400 && value.sp == 0.5){
                  self.market = value;
                }

                if(!self.market)
                  self.market = value;

                Object.values(self.odds).forEach(v => {

                  if(v.market === 5520 && v.sp == 0.5){
                    self.halfMarket = v
                  }

                })


              }else {

                if(value.specialKey === 'sp'){
                  this.ag = ag;

                  if(parseFloat(value.sp) === 0.5 && parseFloat(ag) <= 4.20)
                    self.market = value;

                  if (!self.market && parseFloat(ag) <= 4.20 && (parseFloat(value.sp) % 1 !== 0) && !self.market)
                    self.market = value;

                  ag = 0;


                }else if(value.specialKey === 'hcp'){
                  if (ag <= 4.00)
                    self.market = value;
                  ag = 0;
                }else {
                  
                  self.market = value;
                }
              }


            }
            
          })
        }

        if(!self.match.onLive || self.match.resultName != '1st half'){
                self.halfMarket = null
        }

        console.log(self.market);
      }
  }
}
</script>

<style scoped>
.hide {
  display: none;
}
.no-market {
  opacity: 0.6;
}
</style>


// WEBPACK FOOTER //
// src/components/sportsbook/marketOdd.vue